export enum AlertState {
  IN_PROGRESS = '2',
  CONFIRMED = '1',
  CLOSED = '4',
  SUPPRESSED = '3',
  UNCONFIRMED = '0'
}
